import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { initStateMemberData } from "mocks/memberData";
import { initStateQoData } from "mocks/qoData";
import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import { allowedFields, jsonKeys, mappingQo, mapProductToRequestItem } from "utils/HelperQoFunction";
import * as yup from "yup";
import { clearCreateNewQo, createNewQo } from "../../redux/handlers/logic/createNewQo.handler";
import { clearUpdateNewQo, updateNewQo } from "../../redux/handlers/logic/updateNewQo.handler";
import { useNavigate } from "react-router-dom";
import { getNewQoById } from "../../redux/handlers/logic/getNewQoById.handler";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { nanoid } from "@reduxjs/toolkit";
import { isShowBranch, mappingSearchMember } from "utils/HelperMemberFunction";
export default function useQoForm(param) {
    var qoID = param.qoID, setModalSuccess = param.setModalSuccess, setModalNotApprove = param.setModalNotApprove, setTab = param.setTab, setProductRow = param.setProductRow, columnsort = param.columnsort, setColumnsort = param.setColumnsort, attachments = param.attachments, setAttachments = param.setAttachments, setTagSelected = param.setTagSelected, setUpdateDocIds = param.setUpdateDocIds, modalNotApprove = param.modalNotApprove;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _obj;
    var schema = yup.object().shape((_obj = {
        doc_issue_date: yup.string().required(),
        dim_mst_price_category_id: yup.string().required(),
        fact_member_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required()
    }, _define_property(_obj, "doc_issue_date", yup.string().required()), _define_property(_obj, "doc_expire_date", yup.string().required()), _define_property(_obj, "dim_warehouse_id", yup.string().required()), _define_property(_obj, "dim_branch_id", yup.string().required()), _define_property(_obj, "fact_new_qo_items", yup.array().of(yup.object().shape({
        dim_warehouse_id: yup.string().required("Warehouse ID is required.")
    }))), _define_property(_obj, "member_address", yup.string().required("กรุณาเพิ่มที่อยู่ก่อน")), _define_property(_obj, "not_approve_reason", yup.string().when([], {
        is: function() {
            return modalNotApprove.open;
        },
        then: function(schema) {
            return schema.required();
        }
    })), _obj));
    // Reducers
    var reducers = {
        createNewQo: useAppSelector(function(state) {
            return state.createNewQoReducer;
        }),
        updateNewQo: useAppSelector(function(state) {
            return state.updateNewQoReducer;
        }),
        getNewQoById: useAppSelector(function(state) {
            return state.getNewQoByIdReducer;
        })
    };
    var isLoading = useMemo(function() {
        return reducers.createNewQo.isFetching || reducers.updateNewQo.isFetching || reducers.getNewQoById.isFetching;
    }, [
        reducers.createNewQo.isFetching,
        reducers.updateNewQo.isFetching,
        reducers.getNewQoById.isFetching
    ]);
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(initStateQoData), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initStateMemberData), 2), pdata = _useState2[0], setPdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState("สร้างใบเสนอราคา"), 2), headerName = _useState3[0], setheaderName = _useState3[1];
    var formatResult = function(item) {
        var mappingMember = mappingSearchMember(item);
        var isShowBranchMember = isShowBranch({
            custType: item.member_customer_type,
            isHQ: item.member_is_hq,
            branchNo: item.member_branch_no
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        mappingMember.customerName,
                        isShowBranchMember ? " - (".concat(mappingMember.branchCode, ")") : ""
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "tc-5",
                    children: [
                        mappingMember.customerID ? mappingMember.customerID : "ไม่พบเลขผู้เสียภาษี",
                        " ",
                        "- ",
                        mappingMember.customerCode
                    ]
                })
            ]
        }, nanoid());
    };
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getData = function() {
        dispatch(getNewQoById(qoID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleMainSubmit = function(param) {
        var values = param.values;
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file, index) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = allowedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // console.log(formdataPayload);
        if (!qoID) {
            dispatch(createNewQo(formdataPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(updateNewQo(qoID, formdataPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handlePreSubmit = function(param) {
        var productRow = param.productRow, setFieldValue = param.setFieldValue, handleSubmit = param.handleSubmit, values = param.values, attachments = param.attachments, tagselected = param.tagselected, updateDocIds = param.updateDocIds, setModalAlert = param.setModalAlert, setErrors = param.setErrors;
        var product = productRow.filter(function(prev) {
            return prev.productCode !== "";
        });
        if (product && product.length > 0) {
            var newItems = mapProductToRequestItem(product);
            schema.validate(_object_spread_props(_object_spread({}, values), {
                fact_new_qo_items: newItems,
                attachments: attachments,
                tagselected: tagselected
            }), {
                abortEarly: false
            }).then(function() {
                setFieldValue("doc_files", attachments.map(function(v) {
                    return {
                        docData: v.docFileData,
                        docName: v.docFile
                    };
                }));
                setFieldValue("fact_new_qo_items", newItems);
                setFieldValue("tag_qoes", tagselected);
                if (qoID) {
                    setFieldValue("update_doc_ids", updateDocIds);
                }
                handleSubmit();
            }).catch(function(err) {
                var _err_errors;
                var errorMessage = ((_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : _err_errors.join("\n")) || "Invalid data. Please check the form.";
                console.log(errorMessage);
                var formErrors = {};
                err.inner.forEach(function(e) {
                    if (e.path) formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            });
        } else {
            setModalAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
        }
    };
    useEffect(function() {
        if (reducers.createNewQo.data && !reducers.createNewQo.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            // setFormdisabled(true);
            dispatch(clearCreateNewQo());
            var createdData = reducers.createNewQo.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                navigate("/sale/quotation/edit/".concat(id));
            } else {
                navigate("/sale/quotation");
            }
        }
        if (reducers.updateNewQo.data && !reducers.updateNewQo.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            getData();
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setTab(1);
            dispatch(clearUpdateNewQo());
        }
        if (reducers.getNewQoById.data && !reducers.getNewQoById.isError && qoID) {
            var qoData = reducers.getNewQoById.data.data;
            if (!qoData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingQo({
                qoData: qoData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected
            });
            var endDate = dataWithReplacements.doc_issue_date;
            getHQAddress({
                end_date: endDate
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        reducers.createNewQo.data,
        reducers.updateNewQo.data,
        reducers.getNewQoById.data
    ]);
    useEffect(function() {
        if (qoID) {
            getData();
            setheaderName("แก้ไขใบเสนอราคา");
        } else {
            setFormdata(initStateQoData);
        }
    }, [
        qoID
    ]);
    useEffect(function() {
        if (qoID && (formdata === null || formdata === void 0 ? void 0 : formdata.factDocFileQo)) {
            var deleteCandidateDocIds = formdata.factDocFileQo.map(function(item) {
                return item.id;
            });
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            setUpdateDocIds(deleteDocIds);
        }
    }, [
        formdata,
        attachments
    ]);
    useEffect(function() {
        setIsLoading(isLoading);
    }, [
        isLoading
    ]);
    return {
        schema: schema,
        formdisabled: formdisabled,
        setFormdisabled: setFormdisabled,
        formdata: formdata,
        setFormdata: setFormdata,
        pdata: pdata,
        setPdata: setPdata,
        formatResult: formatResult,
        handleMainSubmit: handleMainSubmit,
        handlePreSubmit: handlePreSubmit,
        headerName: headerName
    };
}
